export enum PlanEnum {
  FEL = 8,
  FREE = 18,
  POS_3 = 20,
  CONTROL = 22, // ex "PRO 3 Usuario"
  DIRECCION = 24, // ex "ERP 5 Usuarios"
  AGIL = 26, // ex "Kolo Esencial"

  // Deprecados: /plans/available ya no los retorna, por lo que no aparecen en
  // el selector. Se conservan porque hay clientes legacy que los tienen
  // contratados. Los planes legacy muestran todas las funciones (default
  // permisivo en usePermissionFromPlan).
  POS_1 = 19,
  PRO_1 = 21,
  ERP_3 = 23,
}

export enum AddonPlanEnum {
  USER = 12,
  POS = 13,
  WAREHOUSE = 14,
  ITEM = 15,
  COMMERCIAL_ESTABLISHMENT = 16,
  INVOICES = 17,
}
